import { PlatFormXDateTimeFormat } from "./helperFns";
import { ScheduleValue } from "./scheduleValidation";

export type ScheduleConfirmation = {
  /** Translation key; each is a sentence fragment meant to follow "Your <content type> ". */
  key: "schedule_confirm_publish" | "schedule_confirm_unpublish" | "schedule_confirm_both";
  /** Interpolation values for the key: `{{publishTime}}` and/or `{{unpublishTime}}`. */
  params: { publishTime?: string; unpublishTime?: string };
};

/**
 * What to tell the editor after a publish that carried a schedule, or null when nothing was
 * scheduled (the normal "published" confirmation applies). Mirrors the three cases the publish
 * planner produces:
 *
 * - publish only      -> "has been scheduled to publish on <time>."
 * - unpublish only    -> "has been published and is scheduled to unpublish on <time>."
 * - both              -> "has been scheduled to publish on <time> and to unpublish on <time>."
 */
export const getScheduleConfirmation = (schedule: ScheduleValue): ScheduleConfirmation | null => {
  const publishAt = schedule.isSchedulePublish ? schedule.schedulePublishDateTime : null;
  const unpublishAt = schedule.isScheduleUnpublish ? schedule.scheduleUnpublishDateTime : null;

  const publishTime = publishAt ? PlatFormXDateTimeFormat(publishAt) : undefined;
  const unpublishTime = unpublishAt ? PlatFormXDateTimeFormat(unpublishAt) : undefined;

  if (publishTime && unpublishTime) {
    return { key: "schedule_confirm_both", params: { publishTime, unpublishTime } };
  }
  if (publishTime) {
    return { key: "schedule_confirm_publish", params: { publishTime } };
  }
  if (unpublishTime) {
    return { key: "schedule_confirm_unpublish", params: { unpublishTime } };
  }
  return null;
};
